const termsAndConditionsData = [
    {
      id: 1,
      title: 'Acceptance of Terms',
      content: 'By using this website, you agree to be bound by these terms and conditions and any additional terms and conditions that may apply to specific sections of the website or to products and services available through the website.'
    },
    {
      id: 2,
      title: 'Use of the Website',
      content: 'This website is intended for personal and non-commercial use only. You may not use this website for any illegal or unauthorized purpose.'
    },
    {
      id: 3,
      title: 'Privacy',
      content: 'Your use of this website is also subject to our Privacy Policy, which can be found at [Privacy Policy Link]. By using the website, you consent to the collection and use of information as described in the Privacy Policy.'
    },
    {
      id: 4,
      title: 'Intellectual Property',
      content: 'All content on this website, including but not limited to text, graphics, logos, button icons, images, and software, is the property of Essentia or its content suppliers and is protected by international copyright laws.'
    },
    {
      id: 5,
      title: 'Product Information',
      content: 'We strive to provide accurate and up-to-date product information, but we cannot guarantee the accuracy or completeness of the information provided on the website.'
    },
    {
      id: 6,
      title: 'Pricing and Payment',
      content: 'Prices displayed on the website are in [Currency] and are subject to change without notice. Payment for orders is accepted through [Payment Methods].'
    },
    {
      id: 7,
      title: 'Order Acceptance',
      content: 'Your receipt of an order confirmation does not signify our acceptance of your order. We reserve the right to accept or decline your order at any time after receiving it.'
    },
    {
      id: 8,
      title: 'Returns and Refunds',
      content: 'Our Returns and Refunds policy can be found at [Returns and Refunds Policy Link].'
    },
    {
      id: 9,
      title: 'Limitation of Liability',
      content: 'In no event shall Essentia or its affiliates be liable for any direct, indirect, punitive, incidental, special, or consequential damages arising out of, or in any way connected with, the use of this website or with the delay or inability to use this website.'
    },
    {
      id: 10,
      title: 'Indemnification',
      content: 'You agree to defend, indemnify, and hold Essentia and its affiliates harmless from and against any and all claims, damages, costs, and expenses, including attorneys\' fees, arising from or related to your use of the website.'
    },
    {
      id: 11,
      title: 'Changes to Terms and Conditions',
      content: 'Essentia reserves the right to revise these terms and conditions at any time without notice. By using this website, you agree to be bound by the current version of these terms and conditions.'
    },
    {
      id: 12,
      title: 'Contact Information',
      content:(
        <p>
          If you have any questions or concerns about these terms and conditions, please contact us at:{' '}
          <strong className="text-yellow-500 hover:underline hover:ease-in-out hover:duration-300">essentiareactjs@gmail.com</strong>
        </p>
      ) }
  ];
  
  export default termsAndConditionsData;
  